<template>
    <div>
        <!-- 报价查看 -->
        <div >
            <vButton theme="primary" class="margin-right-5" @click="alertBox('remark')">添加备注</vButton>
            <vButton v-if="entrydata.orderstatus == 3 || entrydata.orderstatus == 4 || entrydata.orderstatus == 5" theme="success" class="margin-right-5" @click="alertBox('choseFactory')">选择打样工厂</vButton>
            <vButton v-if="entrydata.orderstatus == 3 || entrydata.orderstatus == 4 || entrydata.orderstatus == 5" theme="info" class="margin-right-5" @click="alertBox('submitAudit')">报价确认</vButton>
            <vButton v-if="entrydata.orderstatus == 3 || entrydata.orderstatus == 4 || entrydata.orderstatus == 5 || entrydata.orderstatus == 6" theme="warning" class="margin-right-5" @click="alertBox('entryNews')">录入打样信息</vButton>
        </div>
        <compFormQuery class="margin-top-15 margin-right-15" :formdata="getBase" :value="entrydata" :labelWidth="140"></compFormQuery>
        <div class="text-right">
            <vButton theme="primary" class="margin-left-5" @click="alertBox('exportexcel')">导出</vButton>
        </div>
        <!-- 报价公司 -->
        <vTableSimple
            class="margin-top-15"
            :columns="compcolumns"
            :data="datalist"
            border
        ></vTableSimple>
        <!-- 附件下载 -->
        <compWrapper class="margin-top-15" title="附件" theme="primary">
            <vTableSimple
                class="margin-15"
                :columns="attachlog"
                :data="docList"
                border
            ></vTableSimple>
        </compWrapper>

        <compWrapper class="margin-top-15" title="报告" theme="warning">
             <vTable
                v-for="(item,index) in datalist"
                :key="index"
                class="margin-15"
				:columns="baogaocolumns" 
				:data="getRequestData(item,index)"
                v-show="getRequestData(item,index).length>0 && item.attachMeta!=null ? true:false"
				size="small" 
				ref="tablequery"  
				border
            ></vTable>
            <vTable
                v-for="(item,index) in datalist"
                :key="index"
                class="margin-15"
				:columns="baogaocolumns" 
				:data="getRequestData(item,index)"
                v-show="item.attachMeta===null ? true:false"
				size="small" 
				ref="tablequery"  
				border
            ></vTable>
        </compWrapper>
        <!-- 查看历史 -->
        <compWrapper class="margin-top-15" title="操作历史" theme="gray">
            <compLog :data="logList" ></compLog>
        </compWrapper>

        <!-- 全局弹框 -->
        <compModal
			v-model="modalProps.show"
			v-bind="modalProps"
			@on-close="modalProps.show=false"
			@on-confirm="modalProps={}"
		>
            <component ref="cusref" :is="modalProps.component" @on-close="modalProps={}" v-bind="modalProps" v-on="modalProps.on"></component>
        </compModal>
    </div>
</template>

<script>
import { HttpGetOfferList, HttpRemarkPrimary, HttpGetPrimaryOne } from "@/service/proddevelop";
import compProofing from './proofing';

import mixin from '../../mixins'
export default {
    mixins: [mixin],
    props:['querytype','entrydata'],
    data(){
        return {
            formData:{},
            datalist:[],
            modalProps:{},
            logList:[],
            docList:[],
        }
    },
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compLog: () => import("@components/templates/log"),
        compProofing
    },
    created(){
        this.update()
    },
    computed:{
        getBase(){
            return [
                {
					label: "新品预编码",
					key: "precoding",
                },
                {
                    label: "单据状态",
                    key: "orderstatus",
                    tag: "vSelect",
                    options:this.getPrimaryStatus,
                },
                {
					label: "申请询价时间",
                    key: "submitTime",
                },
                {
					label: "申请人",
                    key: "submitterName",
                },
                {
					label: "报价时间",
                    key: "offerTime",
                },
                {
					label: "报价人",
                    key: "bidderName",
                },
                {
					label: "审核时间",
                    key: "checkOfferTime",
                },
                {
					label: "报价审核人",
                    key: "checkOfferName",
                },
            ]
        },
        compcolumns(){
            return [
                {
					title: "报价公司名称",
					key: "companyName",
                },
                {
					title: "生产提前期",
					key: "productionCycle",
                },
                {
					title: "最小起订量",
					key: "minOrderQty",
                },
                {
					title: "报价（USD）",
					key: "offerUsd",
                },
                {
					title: "报价（CNY）",
					key: "offerCny",
                },
                {
					title: "报价有效期",
					key: "validPeriodTime",
                },
                {
					title: "是否需要打样",
                    key: "isNeedProofing",
                    render:(h,{row})=>{
                        return <div>{row.isNeedProofing == 1 ? '是' : '否'}</div>
                    }
                },
                {
					title: "是否已打样",
                    key: "isProofing",
                    render:(h,{row})=>{
                        return <div>{row.isProofing == 1 ? '是' : '否'}</div>
                    }
                },
                {
					title: "是否中标",
                    key: "status",
                    render:(h,{row})=>{
                        return <div>{row.status == 2 ? '是' : '否'}</div>
                    }
                },
            ]
        },
        attachlog(){
            return [
                {
                    title: '附件名称',
                    key: "attachTitle"
                },
                {
                    title: 'URL',
                    key: "attachUrl"
                },
                // {
                //     title: '操作人',
                //     key: "attachName"
                // },
                {
                    title: '操作时间',
                    key: "attachOpAt"
                },
                {
                    title: '操作',
                    render:(h, { row, index })=>{
                        return h('vButton', {
                            props: {
                                theme: "error",
                                size: 'small',
                            },
                            on: {
                                click: () => {
                                    this.download(row)
                                }
                            },
                            style: {
                                'margin-right': '15px'
                            }
                        }, '下载')
					}
                },
            ]
        },
        baogaocolumns(){
            let _this = this
            return [
				{
					title: '报告名称',
                    key: 'attachTitle',
                    render:(h,{row})=>{
                        return <a href={row.attachUrl} target="_blank">{row.attachTitle}</a>
                    }
                }, 
                {
					title: '操作时间',
                    key: 'attachOpAt'
                },
                {
					title: '操作人',
                    key: 'createdName'
                },
				{
					title: '操作',
                    // width: 120,
                    render(h, { row, index }) {
						return h('div', [
                            h('vButton', {
                                props: {
                                    theme: 'primary',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        _this.downfile(row.attachUrl)
                                    }
                                }
                            }, '下载')
                        ])
					}
				}
			]
        },
    },
    methods:{
        getRequestData(item,index){
            if(item.attachMeta){
                let arraylist = JSON.parse(item.attachMeta).items;
                arraylist.map(jsonone=>{
                //   console.log(jsonone)
                  jsonone.orderid = item.id
                })

                // console.log(arraylist)
                return arraylist
            }else{
                return []
            }
        },
        update(){
            HttpGetOfferList({
                'search[EQ_preselectionId]':this.entrydata.orderid,
                row:20,
                page:1,
            }).then(res=>{
                this.datalist = res.data.content
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
            HttpGetPrimaryOne({id:this.entrydata.orderid}).then(res=>{
                this.docList = res.data.attachMeta ? JSON.parse(res.data.attachMeta).items : [];
            })
        },
        downfile(url){
            this.handleWebfs(url, {}, 'download')
        },
        download(row){
            this.handleWebfs(row.attachUrl, {}, 'download')
        },
        alertBox(type){
            let datajson = {
                orderid:this.entrydata.orderid,
                precoding:this.entrydata.precoding,
                orderstatus:this.entrydata.orderstatus
            }
            switch(type){
                case 'remark':
                    this.modalProps = {
                        show: true,
                        alert: "primary",
                        title: "添加备注",
                        width: 460,
                        showDesc:false,
                        params:{id:this.entrydata.orderid},
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: "备注原因",
                            }
                        ],
                        ajaxRequest:HttpRemarkPrimary,
                        callback:()=>{
                            this.modalProps.show = false;
                            // this.update()
                        }
                    };
                break;
                case 'choseFactory':
                    this.modalProps = {
                        title:'选择打样工厂',
                        show:true,
                        width:1000,
                        component: "compProofing",
                        querydata:datajson,
                        querytype:'chosefactory',
                        showFooter:false,
                        on:{
                            'on-update':()=>{
                                this.update();
                                this.modalProps.show = false;
                            }
                        }
                    }
                    break;
                case 'submitAudit':

                    this.modalProps = {
                        title:'报价确认',
                        show:true,
                        width:1000,
                        component: "compProofing",
                        querydata:datajson,
                        querytype:'submitoffer',
                        showFooter:false,
                        on:{
                            'on-update':()=>{
                                this.update();
                                this.modalProps.show = false;
                            }
                        }
                    }
                    break;
                case 'entryNews':
                    this.modalProps = {
                        title:'录入打样信息',
                        show:true,
                        width:1000,
                        component: "compProofing",
                        querydata:datajson,
                        querytype:'entrynews',
                        showFooter:false,
                        on:{
                            'on-update':()=>{
                                this.update();
                                this.modalProps.show = false;
                            }
                        }
                    }
                    break;
                case 'exportexcel':
                        this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/productDevelopmentOffer/export', {type:0,preselectionId:this.entrydata.orderid}, 'download')
                    break;
            }
        }
    }
    
}
</script>